import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import ArgonButton from 'component/Argon/ArgonButton';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';
import DataTable from 'component/Tables/SelectDataTable';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';

import ActionCell from './component/ActionCell';

import useAuth from 'auth/hook/useAuth';
import useCart from 'hook/useCart';

import { useCreateOrder } from 'api/postOrder';
import { useCreateAdminOrder } from 'api/postOrderAdmin';
import { useValidatePolicy } from 'api/postPolicyValidate';
import axios from 'axios';
import { useCheckPrice } from 'api/postPrice';

// import getCheckCoupon from 'api/getCheckCoupon';
// import FormField from 'component/basicForm/FormField';
const defaultPrice = {
  total: 0,
  amount: 0,
  totalAmount: 0,
  discount: 0,
  creditCollected: 0,
  creditUsage: 0,
  creditNet: 0,
};
function Cart() {
  const [code, setCode] = useState('');
  const [coupon, setCoupon] = useState();
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { items, removeAll, setInvoice, handleSelected, handleRemove, handleRemoveAll } = useCart();
  const { mutateAsync: createOrder } = useCreateOrder();
  const { mutateAsync: validatePolicy } = useValidatePolicy();
  const { mutateAsync: createAdminOrder } = useCreateAdminOrder();
  const { mutateAsync: checkPrice, isLoading } = useCheckPrice();
  const [price, setPrice] = useState(defaultPrice);

  useEffect(() => {
    if (items?.length) {
      checkPrice({ data: items, coupon: coupon?.coupon || code })
        .then((data) => {
          console.log(data);
          setPrice(data);
        })
        .catch(console.error);
    } else if (items?.length === 0) {
      setPrice(defaultPrice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items?.length]);

  const isAdmin = useMemo(() => {
    if (auth?.roles) {
      if (auth?.roles?.includes(5150)) {
        return true;
      }
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.accessToken]);

  const handleSubmit = () => {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        createOrder({ data: items, coupon: coupon?.coupon || code })
          .then((data) => {
            console.log(data);
            setInvoice(data.invoiceId);
            removeAll();
            Swal.close();
            navigate(`/order/payment/${data.invoiceId}`, { replace: true });
          })
          .catch((err) => {
            setCoupon();
            setCode('');
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  };

  const handldeValidate = () => {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        validatePolicy(items)
          .then(() => {
            createOrder({ data: items, coupon: coupon?.coupon || code })
              .then((data) => {
                console.log(data);
                setInvoice(data.invoiceId);
                removeAll();
                Swal.close();
                navigate(`/order/payment/${data.invoiceId}`, { replace: true });
              })
              .catch((err) => {
                setCoupon();
                setCode('');
                let errMsg = handleAxios(err);
                Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
              });
          })
          .catch((err) => {
            setCoupon();
            setCode('');
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  };

  function handleComfirm() {
    const newSwal = Swal.mixin({
      customClass: {
        confirmButton: 'button button-success',
        cancelButton: 'button button-error',
      },
      buttonsStyling: false,
    });

    newSwal
      .fire({
        title: 'ยืนยันคำสั่งซื้อ?',
        text: `จำนวน ${items.length} กรมธรรม์ / มูลค่า ${price.amount} บาท`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      })
      .then((result) => {
        if (result.isConfirmed) {
          newSwal.close();
          handldeValidate();
        }
      });
  }

  const handleAdminSubmit = () => {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        createAdminOrder({ data: items })
          .then((data) => {
            console.log(data);
            setInvoice(data.invoiceId);
            removeAll();
            Swal.close();
            navigate(`/order/${data.invoiceId}`, { replace: true });
          })
          .catch((err) => {
            setCoupon();
            setCode('');
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  };

  function handleAxios(err) {
    let errMsg;
    if (axios.isAxiosError(err)) {
      if (err.response?.data) {
        errMsg = err.response.data;
      }
    }
    return errMsg;
  }

  return (
    <DashboardLayout bgColor="success">
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <ArgonBox>
              <Card>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                  <ArgonBox lineHeight={1}>
                    <ArgonTypography variant="h5" fontWeight="medium">
                      สั่งซื้อกรมธรรม์
                    </ArgonTypography>
                    <ArgonTypography variant="button" fontWeight="regular" color="text">
                      รายการรายละเอียด
                    </ArgonTypography>
                  </ArgonBox>
                  <ArgonBox>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <ArgonButton size="small" variant="gradient" color="error" onClick={handleRemove}>
                        ลบ
                      </ArgonButton>
                      <ArgonButton size="small" variant="gradient" color="error" onClick={handleRemoveAll}>
                        ลบทั้งหมด
                      </ArgonButton>
                    </Stack>
                  </ArgonBox>
                </ArgonBox>

                <ArgonBox px={3}>
                  <DataTable
                    onSelected={handleSelected}
                    table={{
                      columns: [
                        {
                          Header: 'ชื่อ',
                          Cell: ({ row }) => {
                            const data = row.original;
                            return data?.name.concat(data?.surename ? ' ' + data?.surename : '');
                          },
                        },
                        {
                          Header: 'เลขประจำตัว',
                          Cell: ({ row }) => {
                            const data = row.original;
                            return data.idCard || data?.alcode;
                          },
                        },
                        {
                          Header: 'เมนู',
                          maxWidth: 20,
                          minWidth: 10,
                          width: 10,
                          Cell: ({ row }) => <ActionCell row={row} />,
                        },
                      ],
                      rows: items,
                    }}
                    entriesPerPage={{
                      defaultValue: 25,
                      entries: [25, 50, 100],
                    }}
                    canSearch
                  />
                </ArgonBox>

                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" px={3}>
                  <ArgonBox />
                  <Stack spacing={1} direction="column">
                    <ArgonTypography variant="subtitle1" fontWeight="bold" color="text" align="right">{`รวม ${
                      isLoading ? '...' : price?.amount || '0'
                    } บาท`}</ArgonTypography>
                    <ArgonTypography variant="body2" fontWeight="regular" color="text" align="right">{`ส่วนลด ${
                      isLoading ? '...' : price?.discount || '0'
                    } บาท`}</ArgonTypography>
                  </Stack>
                </ArgonBox>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                  <ArgonBox />
                  <Stack spacing={1} direction="row">
                    {isAdmin && (
                      <ArgonButton
                        variant="gradient"
                        color="primary"
                        size="small"
                        disabled={items.length <= 0}
                        onClick={handleAdminSubmit}
                      >
                        สร้างกรมธรรม์{` (${items.length})`}
                      </ArgonButton>
                    )}
                    <ArgonButton
                      variant="gradient"
                      color="primary"
                      size="small"
                      disabled={items.length <= 0}
                      onClick={handleComfirm}
                    >
                      ชำระเงิน{` (${items.length})`}
                    </ArgonButton>
                  </Stack>
                </ArgonBox>
              </Card>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
    </DashboardLayout>
  );
}

export default Cart;
